import { strategy } from "./providers";

export const { Provider, track, identify, reset } = strategy;
